import { render, staticRenderFns } from "./NotificationsColumn.vue?vue&type=template&id=74c1ce8a&"
import script from "./NotificationsColumn.vue?vue&type=script&lang=js&"
export * from "./NotificationsColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74c1ce8a')) {
      api.createRecord('74c1ce8a', component.options)
    } else {
      api.reload('74c1ce8a', component.options)
    }
    module.hot.accept("./NotificationsColumn.vue?vue&type=template&id=74c1ce8a&", function () {
      api.rerender('74c1ce8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components-globalwork/notifications/NotificationsColumn.vue"
export default component.exports